import React from 'react';
import { Clock, TrendingUp, LineChart } from 'lucide-react';

const ProjectionSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <LineChart className="w-5 h-5 mr-2 text-purple-500" />
        Параметры прогнозирования
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Период прогнозирования */}
        <div>
          <label htmlFor="projectionPeriod" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-purple-500" />
            Период прогнозирования (лет)
          </label>
          <input
            type="text"
            id="projectionPeriod"
            name="projectionPeriod"
            value={formData.projectionPeriod}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.projectionPeriod ? 'input-error' : ''}`}
            placeholder="Введите количество лет"
          />
          {errors.projectionPeriod && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.projectionPeriod}
            </p>
          )}
        </div>

        {/* Включение роста стоимости акций */}
        <div className="flex items-center">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeStockGrowth"
              checked={formData.includeStockGrowth}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать изменение стоимости акций
            </span>
          </label>
        </div>

        {/* Темп роста стоимости акций (отображается только если включен рост) */}
        {formData.includeStockGrowth && (
          <div className="col-span-full">
            <label htmlFor="stockGrowthRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <TrendingUp className="w-4 h-4 mr-2 text-purple-500" />
              Годовой рост стоимости акций (%)
            </label>
            <input
              type="text"
              id="stockGrowthRate"
              name="stockGrowthRate"
              value={formData.stockGrowthRate}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.stockGrowthRate ? 'input-error' : ''}`}
              placeholder="Введите процент роста"
            />
            {errors.stockGrowthRate && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.stockGrowthRate}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Значение может быть как положительным (рост), так и отрицательным (падение).
            </p>
          </div>
        )}
      </div>

      <div className="mt-4 bg-purple-100 dark:bg-purple-900/30 p-3 rounded-lg">
        <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">О прогнозировании</h4>
        <p className="text-xs text-purple-600 dark:text-purple-400">
          Помните, что прогнозы основаны на текущих параметрах и могут не совпадать с реальностью.
          Рынок акций подвержен значительным колебаниям, а компании могут менять дивидендную политику.
          Используйте эти расчеты как ориентир, а не как гарантию доходности.
        </p>
      </div>
    </div>
  );
};

export default ProjectionSection;